import './styles/app.scss'
import HomePage from './components/homepage'

function App() {
  return <HomePage />
}

export default App
